import { basicPath } from '../basicPath';

export const fetchMemberOverduePayments = (params) => async (dispatch) => {
    const path = '/mp/member/payments/overdue';
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const createStripeCheckoutSession = (params) => async (dispatch) => {
    const path = '/mp/member/payments/create-checkout-session';
    const type = 'post';
    return await basicPath(dispatch, params, path, type);
}

export const fetchMemberPaymentHistory = (params) => async (dispatch) => {
    const path = '/mp/member/payments/history';
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

